import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

/**
 * TODO(aled): My recommendation is to remove this component.
 * It is not necessary to wrap an Angular material component in another component.
 **/

@Component({
	selector: 'app-date-picker',
	template: require('./date-picker.component.html'),
	styles: [require('./date-picker.component.scss')],
	providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
})
export class DatePickerComponent {
	@Input() controlDate: Date;
	@Output() onSave: EventEmitter<Date> = new EventEmitter();

	constructor(private adapter: DateAdapter<any>) {
		this.adapter.setLocale('en-GB');
	}

	onChange($event: MatDatepickerInputEvent<Date>) {
		this.onSave.emit($event.value);
	}
}
